import * as React from 'react';
import { connect } from 'react-redux';

import { navigate } from '~/router';
import { redirectToHome } from '../../helpers';

import PageWrapper from '~/common/layout/PageWrapper';
import Home from '../../components/app/Home';


class HomePage extends React.Component<any, any> {
  componentDidMount() {
    redirectToHome(this.props.user, this.props.orgs.entities[this.props.user.organizationId]);
  }

  render() {
    return (
      <React.Fragment>
        <PageWrapper>
          <Home />
        </PageWrapper>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.shared.auth.currentUser,
    orgs: state.shared.organizations,
  }
};


export default connect(mapStateToProps)(HomePage) as any;
